import React from "react";
import {Button, Space, Table} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {config} from "../../../../../../shared/config/config";
import {ApiAdvertisingService} from "../../../../../../shared/api";
import {countText, SectionToolbar, useSectionSearch} from "../../../components/SectionToolbar/SectionToolbar";
import {useCanEdit} from "../../../../sectionAccess";

export const AdvertisingTable = ({advertiseList, setIsOpenedDrawer, setEditableSlide, setEditableSlideId, fetchSlides }) => {
  const canEdit = useCanEdit()
  const [search, setSearch, slides] = useSectionSearch(advertiseList, ['order_url', 'priority'])

  const tableColumns = [
    {
      title: 'Ссылка',
      dataIndex: 'order_url',
      key: 'url',
      render: (text) => text
    },
    {
      title: 'Приоритет',
      dataIndex: 'priority',
      key: 'priority',
      render: (text) => text
    },
    {
      title: 'Слайд',
      dataIndex: 'fileName',
      key: 'fileName',
      render: (fileName) => <img alt='slide' style={{width: '50px', height: '50px', objectFit: 'cover'}} src={`${config.API_HOST}/media/${fileName}`}/>
    },
    canEdit && {
      title: 'Действия',
      key: 'actions',
      width: 260,
      render: ({ id }) => (
        <Space size="small">
          <Button
            onClick={() => {
              setEditableSlideId(id)
              setEditableSlide(id)
              setIsOpenedDrawer(true)
            }}
          >
            Изменить
          </Button>
          <Button
            danger
            onClick={() => {
              let isAgree = window.confirm(`Вы уверены что хотите удалить слайд?`)
              if (isAgree) {
                ApiAdvertisingService.delete(id).then(() => fetchSlides())
              }
            }}
          >
            Удалить
          </Button>
        </Space>
      ),
    },
  ].filter(Boolean);
  return (
    <Table
      bordered={true}
      title={() => (
        <SectionToolbar
          search={search}
          onSearch={setSearch}
          placeholder='Ссылка слайда'
          count={countText((advertiseList || []).length, slides.length, search)}
        >
          {canEdit && (
            <Button type="primary" icon={<PlusOutlined/>} onClick={() => setIsOpenedDrawer(true)}>
              Создать рекламный слайд
            </Button>
          )}
        </SectionToolbar>
      )}
      columns={tableColumns}
      dataSource={slides}
      locale={{emptyText: search ? 'Ничего не нашлось' : 'Слайдов пока нет'}}
      showHeader={true}
      rowKey="id"
      showSorterTooltip={false}
    />
  )
}
